import { render, staticRenderFns } from "./manage-admin.vue?vue&type=template&id=e31398ac&scoped=true"
import script from "./manage-admin.vue?vue&type=script&lang=ts"
export * from "./manage-admin.vue?vue&type=script&lang=ts"
import style0 from "./manage-admin.vue?vue&type=style&index=0&id=e31398ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e31398ac",
  null
  
)

export default component.exports